import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Drawer,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import {
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../../../../api";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import SettleDues from "./SettleDues";
import ViewBookingLoader from "./ViewBookingLoader";

function ViewBooking({
  onClose,
  fetchBookingData,
  hotelId,
  eventData,
  singleSpaceInfo,
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 2,
    border: "1px solid #E0E0E0",
    p: 2,
  };
  console.log("eventData", eventData);
  const [invoiceData, setInvoiceData] = useState({});
  const [packages, setPackages] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [cancelBookingLoader, setCancelBookingLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [openCancelBookingModal, setOpenCancelBookingModal] = useState(false);

  const getInvoiceData = () => {
    setLoader(true);
    handleSpringDataRequest(
      `core/api/v1/non-rental-booking/invoice-data-render?bookingId=${eventData?.event?.extendedProps?.bookingId}`
    )
      .then((resp) => {
        setLoader(false);
        setInvoiceData(resp);
      })
      .catch(() => {
        setLoader(false);
      });
  };
  const getPackages = () => {
    handleSpringDataRequest(
      `core/api/v1/non-rental/get-all-non-rental-package?nonRentalTypeId=${singleSpaceInfo?.id}`
    )
      .then((res) => {
        setPackages(res);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    getPackages();
  }, []);

  useEffect(() => {
    if (eventData?.event?.extendedProps?.bookingId) {
      getInvoiceData();
    }
  }, [eventData]);

  const handleCancelBooking = () => {
    setCancelBookingLoader(true);
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/non-rental-booking/cancel-booking`,
      {
        hotelId: hotelId,
        bookingId: eventData?.event?.extendedProps?.bookingId,
      }
    )
      .then(() => {
        fetchBookingData();
        setCancelBookingLoader(false);
        setOpenCancelBookingModal(false);
        onClose();
      })
      .catch(() => {
        onClose();
        setOpenCancelBookingModal(false);
        setCancelBookingLoader(false);
      });
  };
  return (
    <Box sx={{ width: 700, p: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Typography sx={{ fontSize: 20, fontWeight: 500 }}>
          Booking Summary
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      {loader ? (
        <ViewBookingLoader />
      ) : (
        <Box
          sx={{
            p: 1,
            border: "1px solid #E0E0E0",
            borderRadius: 2,
          }}
        >
          {/* <Divider sx={{ mb: 2 }} /> */}

          {[
            { label: "Package", value: "name", parentKey: "nrPackageInfo" },
            { label: "Check-in", value: "checkin", parentKey: "nrBookingInfo" },
            {
              label: "Check-out",
              value: "checkout",
              parentKey: "nrBookingInfo",
            },
            {
              label: "Guests",
              value: "num_people",
              parentKey: "nrBookingInfo",
            },
            {
              label: "Contact Name",
              value: "contact_person",
              parentKey: "nrBookingInfo",
            },
            {
              label: "Contact Phone",
              value: "contact_number",
              parentKey: "nrBookingInfo",
            },
            {
              label: "Contact Email",
              value: "contact_email",
              parentKey: "nrBookingInfo",
            },
          ].map((item) => (
            <Box
              key={item.label}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 1.2,
              }}
            >
              <Typography
                sx={{ fontSize: 14, fontWeight: 400 }}
                color="text.secondary"
              >
                {item.label}
              </Typography>
              <Typography sx={{ fontSize: 14 }} fontWeight={500}>
                {invoiceData?.[item?.parentKey]?.[item.value]}
              </Typography>
            </Box>
          ))}

          <Divider sx={{ my: 2 }} />

          {[
            { label: "Balance due", value: `balance_due` },
            { label: "Room Amount", value: `total_amount` },
            { label: "Tax Amount", value: `total_tax` },
            {
              label: "Total Amount",
              value: `total_booking_amount_after_tax`,
              highlight: true,
            },
          ].map((item) => (
            <Box
              key={item.label}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 1,
              }}
            >
              <Typography
                color={item.highlight ? "primary" : "text.secondary"}
                sx={
                  item.highlight
                    ? { fontWeight: 600, fontSize: 14 }
                    : { fontSize: 14 }
                }
              >
                {item.label}
              </Typography>
              <Typography
                color={item.highlight ? "primary" : "text.primary"}
                sx={
                  item.highlight
                    ? { fontWeight: 600, fontSize: 14 }
                    : { fontSize: 14 }
                }
              >
                {invoiceData?.nrBookingInfo?.[item?.value]}
              </Typography>
            </Box>
          ))}
        </Box>
      )}

      <Box sx={{ mt: 2 }}>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="custom-button"
            onClick={() =>
              window.open(
                `/rental-folio/${eventData?.event?.extendedProps?.bookingId}?hotelId=${hotelId}`,
                "_blank"
              )
            }
          >
            View folio
          </Button>
          <Button variant="custom-button" onClick={() => setOpenDrawer(true)}>
            {" "}
            Settle Dues
          </Button>
          <Button
            variant="custom-button"
            onClick={() => setOpenCancelBookingModal(true)}
          >
            Cancel Booking
          </Button>
        </Box>
      </Box>
      <Drawer anchor={"right"} open={openDrawer}>
        <SettleDues setOpenDrawer={setOpenDrawer} invoiceData={invoiceData} />
      </Drawer>
      <Modal
        open={openCancelBookingModal}
        onClose={() => setOpenCancelBookingModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Do you want to cancel the booking id{" "}
            {eventData?.event?.extendedProps?.bookingId} ?
          </Typography>
          <Box sx={{ mt: 4, display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="outlined"
              onClick={() => setOpenCancelBookingModal(false)}
              sx={{ textTransform: "none" }}
            >
              No
            </Button>
            <Button
              variant="custom-button"
              onClick={handleCancelBooking}
              disabled={cancelBookingLoader}
            >
              Yes{" "}
              {cancelBookingLoader && (
                <CircularProgress size={15} color="inherit" sx={{ ml: 1.5 }} />
              )}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default ViewBooking;
